export default __webpack_public_path__ + "media/Non-food-Other.374901e8.png";